module.exports = __webpack_public_path__ + "img/v3-issue-low.434f4143.svg";